<template>
	<div class="archive-automation-entry-wrapper">
	<div class="entry panel-item archive-automation-entry" style="z-index: 2">

		<a @click.prevent="$router.push('/automations/'+automation.id)" class="list-item-link">

			<div class="flex-none __img">
				<inline-svg :src="require('@/assets/img/logo-grey.svg')" />
			</div>

			<div class="__caption">
				<div class="__name">{{ automation.name }}</div>
				<span>Deleted {{ date(automation.deleted_at).diff }}</span>
			</div>
		</a>

		<div class="layout-row flex-center flex-none __btns">
			<v-button class="__restore_btn" label="Restore" @click="restore()"
			          :icon="require('@/assets/img/go_back_arrow-ex.svg')"
			          border slim v-tippy="{theme:'small-black'}" content="Restore deleted automation" :loading="restoring" />
		</div>

	</div>
	</div>
</template>

<script>
import API from "@/api";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
import VButton from "@/components/base/v-button";
import Loading from "@/components/Loading";
import {is} from "@/helpers/roles";
import VSwitch from "@/components/base/v-switch";
import VSpinner from "@/components/base/v-spinner";

TimeAgo.addLocale(en);
const timeAgo = new TimeAgo("en-US");

export default {
	name: "archive-automation-entry",
	components: {
		VSpinner,
		VSwitch, Loading, VButton},
	props: ['automation'],
	mixins: [API],
	data() {
		return {
			restoring:false,
		}
	},
	computed: {
	},
	methods: {
		is(role){
			return is(role)
		},
		date(string) {
			var date = new Date(string);
			var monthArr = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
			var month = monthArr[date.getMonth()];
			var day = date.getDate();
			var hours = date.getHours();
			var minutes = date.getMinutes();

			var format = `${month} ${day} ${hours}:${minutes}`;
			var diff = timeAgo.format(date);
			//Feb 26 16:58
			return {format, diff};
		},

		async restore() {
			try {
				this.restoring = true;
				let res = await this.api.globalAutomations.restore(this.automation.id);
				if (!res.error) {
					this.$emit('restored', res)
					this.$router.push(`/automations/${this.automation.id}`)
				}
			} catch (e) {
				this.$error(e)
			} finally {
				this.restoring = false;
			}
		},
	}
};
</script>

<style lang="scss" scoped>
.archive-automation-entry {
	background: $light-silver;
	cursor: default;
	fill: grey;

	&:hover {
		background: $light-silver;
	}
	.list-item-title {
		color: $dark-grey;
	}
	.__restore_btn {
		border: 1px solid $grey;
		color: #434244;
		width: fit-content !important;
		white-space: nowrap;
		flex-direction: row !important;
		display: flex !important;
		height: 28px !important;
		&:hover {
			background: white !important;
			border: 1px solid $dark-grey;
		}
	}

.__img {
	width: 40px;
	height: 40px;
	display: flex;
	margin-right: 15px;
	color: #6b6c70;
	align-items: center;
	svg {
		width: 28px;
		height: 28px;
	}
}

	.__caption {
		display: flex;
		flex-direction: column;
		flex: 1;
		gap: 5px;

		.__name {
			font-weight: 600;
			font-size: 16px;
		}
	}
	.__btns {
		display: flex;
		flex-direction: row;
		flex: 0;
		align-items: center;
		gap: 15px;

		.__switch:hover {
			background: $dark-hover-light-blue;
			border-radius: 8px;
		}
		a {
			border-radius: 8px;
			width: 36px;
			height: 36px;
			display: flex;
			justify-content: center;
			flex-direction: column;
			align-items: center;
			position: relative;
			&:hover {
				background: $dark-hover-light-blue;
				color: $darker-grey;
			}
			&.delete_btn {
				color: $light-red;
				opacity: 0.7;
				&:hover {
					color: $light-red;
					opacity: 1;
				}
			}
		}
	}
}

.archive-automation-entry-wrapper {


}
</style>
